import { fetchAll } from './fetch';
import Credit from 'models/credit';

export default fetchAll('credits', Credit);
